import React from 'react';
import { Hero } from '../components/Hero';
import { Manufacturers } from '../components/Manufacturers';
import { PumpTypes } from '../components/PumpTypes';
import { Applications } from '../components/Applications';
import { RepairKits } from '../components/RepairKits';
import { Resources } from '../components/Resources';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function PumpsPage() {
  return <>
      <Hero data-id="element-341" />
      <Manufacturers data-id="element-342" />
      <PumpTypes data-id="element-343" />
      <Applications data-id="element-344" />
      <RepairKits data-id="element-345" />
      <Resources data-id="element-346" />
      <FAQ data-id="element-347" />
      <FinalCTA data-id="element-348" />
    </>;
}